export interface RuntimeConfig {
  readonly authApiBaseUrl: string
  readonly reportingApiBaseUrl: string
}

function isRuntimeConfig(value: unknown): value is RuntimeConfig {
  if (typeof value !== 'object' || value === null) return false
  const candidate = value as Record<string, unknown>
  return typeof candidate.authApiBaseUrl === 'string' && typeof candidate.reportingApiBaseUrl === 'string'
}

export class RuntimeConfigError extends Error {}

export async function loadRuntimeConfig(fetchImpl: typeof fetch = fetch): Promise<RuntimeConfig> {
  const response = await fetchImpl(new URL('/config.json', window.location.origin), { cache: 'no-store' })
  if (!response.ok) {
    throw new RuntimeConfigError(`/config.json answered ${response.status}`)
  }
  const body: unknown = await response.json()
  if (!isRuntimeConfig(body)) {
    throw new RuntimeConfigError('/config.json is not shaped like a RuntimeConfig')
  }
  return body
}
